import api from './api';

const B = '/api/client-import';
const d = (r) => r.data;
export const importAPI = {
  upload: (file) => { const fd = new FormData(); fd.append('file', file); return api.post(`${B}/upload`, fd).then(d); },
  preview: (id, body) => api.post(`${B}/${id}/preview`, body).then(d),
  apply: (id, body) => api.post(`${B}/${id}/apply`, body).then(d),
  rollback: (id, cascade = false) => api.post(`${B}/${id}/rollback`, { cascade }).then(d),
  history: () => api.get(`${B}/history`).then(d),
  get: (id) => api.get(`${B}/${id}`).then(d),
  discard: (id) => api.delete(`${B}/${id}`).then(d),
  mappings: () => api.get(`${B}/mappings`).then(d),
  saveMapping: (body) => api.post(`${B}/mappings`, body).then(d),
  bulkInvite: (ids) => api.post('/api/clients/bulk-invite', { client_ids: ids }).then(d),
};

export const errText = (e) => {
  const x = e?.response?.data?.detail;
  return typeof x === 'string' ? x : Array.isArray(x) ? x.map((y) => y.msg).join('; ') : 'Something went wrong';
};

export const FIELD_LABELS = {
  display_name: 'Client name *', xpm_client_code: 'Client code', entity_type: 'Business structure', first_name: 'First name', last_name: 'Last name',
  email: 'Email', phone: 'Phone', mobile: 'Mobile', abn: 'ABN', acn: 'ACN', tfn: 'TFN', date_of_birth: 'Date of birth', website: 'Website', status: 'Status / archived',
  postal_line1: 'Postal address 1', postal_line2: 'Postal address 2', postal_line3: 'Postal address 3', postal_suburb: 'Postal suburb', postal_state: 'Postal state',
  postal_postcode: 'Postal postcode', postal_country: 'Postal country', physical_line1: 'Physical address 1', physical_line2: 'Physical address 2',
  physical_line3: 'Physical address 3', physical_suburb: 'Physical suburb', physical_state: 'Physical state', physical_postcode: 'Physical postcode', physical_country: 'Physical country',
  legal_name: 'Legal / organisation name', trading_name: 'Trading name', industry: 'Industry', financial_year_end: 'Financial year end', xero_subscriber_email: 'Xero subscriber email',
};
export const ENTITY_CHOICES = [['individual', 'Individual'], ['sole_trader', 'Sole trader'], ['company', 'Company'], ['trust', 'Trust'], ['partnership', 'Partnership'], ['smsf', 'SMSF'], ['other', 'Other']];
